import Box from "@mui/material/Box"
import CircularProgress from "@mui/material/CircularProgress"
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded"

import { useAppliance } from '@/hooks/use-appliance'
import type { Appliance } from '@/types'

interface ApplianceLoaderProps {
    applianceId: string | number,
    children: (data: Appliance) => React.ReactNode
}

const ApplianceLoader: React.FC<ApplianceLoaderProps> = ({
    applianceId,
    children,
}) => {
    const { status, data, error } = useAppliance(applianceId, {
        refetchOnMount: false, // @hotfix infinite refetch caused by mounts triggering it
    })

    if (status === 'pending') {
        return (
            <CircularProgress />
        )
    }

    if (error) {
        return (
            <Box>
                <ErrorOutlineRoundedIcon />
                <Box>{error.message}</Box>
            </Box>
        )
    }

    if (data) {
        return <>{children(data)}</>
    }

    return null
}

export default ApplianceLoader
